import { render, staticRenderFns } from "./VendorCodeManagement.vue?vue&type=template&id=5fe1dac5&"
import script from "./VendorCodeManagement.vue?vue&type=script&lang=js&"
export * from "./VendorCodeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports